module.exports = __webpack_public_path__ + "img/2.b791504e.png";